import { useLocation } from 'react-router-dom';
import usePrevious from './usePrevious';
import type { Location } from 'history';

/**
 * Intercept location change in sync and triggers given callback
 * If you have use case: To do something on location change before
 * anything else in your component i.e. use this in your render.
 */
const useLocationChangeSync = (onChange: (location: Location) => void) => {
  const location = useLocation();
  const prevLocation = usePrevious(location);
  if (!prevLocation || prevLocation?.pathname !== location.pathname) {
    onChange(location);
  }
};

export default useLocationChangeSync;
